import { GET_ALL_USERS, GET_USERS_ENDPOINT } from "../constants/endpoints";
import { ResponseProps, request } from "./request";

export const fetchUsersWithGroup = async (
  group: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem("gatewayURL")}${GET_USERS_ENDPOINT}${group}`
  );

  if (r.success) {
    const data = r.data;
    return { success: r.success, data: data, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const getUserPreferences = async (): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  const r: ResponseProps = (await request.get(
    `${sessionStorage.getItem("gatewayURL")}/accounts/v1/users/preferences`
  )) as ResponseProps;

  if (r.success) {
    const form = r.data as any;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, message: r.message };
};

export const fetchAllUsers = async (): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  const r: ResponseProps = (await request.get(
    `${sessionStorage.getItem("gatewayURL")}${GET_ALL_USERS}`
  )) as ResponseProps;

  if (r.success) {
    const form = r.data as any;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, message: r.message };
};
